// SignChangeCard
import { ChangeCardInfo } from '../globals/change-card-info';
import { ENDPOINT } from '../globals/endpoint';
import { apiHelper } from '../helpers/api-helper';

export const updateChangeCard = async (changedCard: Partial<ChangeCardInfo>) => {
  const endpoint = ENDPOINT.SignChangeCard;

  const response = await apiHelper(endpoint, {
    method: 'POST',
    body: JSON.stringify({ ...changedCard }),
  });

  const resp = await response.json();

  return response.ok ? resp : void 0;
};
